import './App.scss';

import React, {useEffect} from 'react';
import Router from './routing/Router';

import {detectNative} from './utilities';

const App = () => {
  useEffect(() => {
    // if (window && window.AppStore && window.AppActions) {
    //   window.AppStore = AppStore;
    //   window.AppActions = AppActions;
    // }
    detectNative();

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

  }, []);


  return (
    <main className={'App'}>
      <Router/>
    </main>
  );
}

export default App;